export const NEWS_MISSING_IMAGE_PATH = "https://s3.eu-central-1.wasabisys.com/calcio-com/news/banner-default.jpeg"
export const GUIDES_MISSING_IMAGE_PATH = "https://s3.eu-central-1.wasabisys.com/calcio-com/news/banner-default.jpeg"
export const TEAM_MISSING_IMAGE_PATH = "/img/football-club.png"
export const PLAYER_MISSING_IMAGE_PATH =
  "https://s3.eu-central-1.wasabisys.com/calcio-com/placeholder/soccer-player-calcio.png"
export const COMPETITION_MISSING_IMAGE_PATH = "https://s3.eu-central-1.wasabisys.com/calcio-com/placeholder/trophy.png"
export const BOOKMAKER_BONUS_IMAGE_PATH =
  "https://s3.eu-central-1.wasabisys.com/calcio-com/images/bookmaker-bonuses/placeholder.webp"
